var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardOptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 16,
    viewBox: "0 0 111 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1389_42518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 0.25H5.25C4.14543 0.25 3.25 1.14543 3.25 2.25V13.75C3.25 14.8546 4.14543 15.75 5.25 15.75H24.75C25.8546 15.75 26.75 14.8546 26.75 13.75V2.25C26.75 1.14543 25.8546 0.25 24.75 0.25Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78773 5.91444C5.26459 5.62751 4.66754 5.39674 4 5.23659L4.028 5.11188H6.76498C7.13596 5.12489 7.43699 5.23651 7.53495 5.63071L8.12977 8.46659L8.31198 9.32073L9.97797 5.11188H11.7768L9.10288 11.2775H7.30397L5.78773 5.91444ZM13.1 11.2841H11.3988L12.4628 5.11188H14.1639L13.1 11.2841ZM19.2668 5.26277L19.0354 6.59559L18.8816 6.53004C18.5737 6.40525 18.1674 6.28054 17.6144 6.29371C16.9427 6.29371 16.6415 6.56277 16.6345 6.82546C16.6345 7.11441 16.9989 7.30484 17.5939 7.58725C18.574 8.02719 19.0286 8.56557 19.0218 9.26819C19.0081 10.5486 17.846 11.3761 16.0611 11.3761C15.2979 11.3694 14.5628 11.2181 14.1638 11.0476L14.4019 9.66205L14.6259 9.76066C15.1789 9.99071 15.5428 10.089 16.222 10.089C16.7118 10.089 17.2369 9.89838 17.2436 9.48488C17.2436 9.21565 17.0199 9.01851 16.3617 8.71646C15.7178 8.42087 14.8568 7.92848 14.8708 7.04198C14.8781 5.84042 16.0611 5 17.741 5C18.399 5 18.9312 5.13789 19.2668 5.26277ZM21.5278 9.09749H22.9417C22.8718 8.78889 22.5496 7.31147 22.5496 7.31147L22.4307 6.77964C22.3467 7.00943 22.1999 7.38373 22.2069 7.37056C22.2069 7.37056 21.6678 8.7429 21.5278 9.09749ZM23.6276 5.11188L25 11.284H23.4249C23.4249 11.284 23.2708 10.5748 23.2219 10.3581H21.0378C20.9746 10.5222 20.6808 11.284 20.6808 11.284H18.8958L21.4226 5.62399C21.5977 5.22342 21.906 5.11188 22.3118 5.11188H23.6276Z",
    fill: "#171E6C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1389_42518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 0H33C31.8954 0 31 0.89543 31 2V14C31 15.1046 31.8954 16 33 16H53C54.1046 16 55 15.1046 55 14V2C55 0.89543 54.1046 0 53 0Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 13C42.7614 13 45 10.7614 45 8C45 5.23858 42.7614 3 40 3C37.2386 3 35 5.23858 35 8C35 10.7614 37.2386 13 40 13Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 13C48.7614 13 51 10.7614 51 8C51 5.23858 48.7614 3 46 3C43.2386 3 41 5.23858 41 8C41 10.7614 43.2386 13 46 13Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 4C44.2144 4.91221 45 6.36455 45 8.00037C45 9.63618 44.2144 11.0885 43 12.0007C41.7856 11.0885 41 9.63618 41 8.00037C41 6.36455 41.7856 4.91221 43 4Z",
    fill: "#FF5F00"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1389_42518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 0H61C59.8954 0 59 0.89543 59 2V14C59 15.1046 59.8954 16 61 16H81C82.1046 16 83 15.1046 83 14V2C83 0.89543 82.1046 0 81 0Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7656 13.3948V7.69336L82.9132 7.70246V9.27736L81.7403 10.5308L82.9132 11.7956V13.4039H81.0405L80.0454 12.3058L79.0572 13.4081L72.7656 13.3948Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4414 12.7692V8.32031H77.2137V9.3452H74.6628V10.0409H77.1529V11.0487H74.6628V11.732H77.2137V12.7692H73.4414Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1954 12.7691L79.2827 10.5421L77.1953 8.32031H78.811L80.0865 9.73035L81.3656 8.32031H82.9117V8.35532L80.8689 10.5421L82.9117 12.706V12.7691H81.35L80.0519 11.3449L78.7671 12.7691H77.1954Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2388 2.63281H75.6849L76.544 4.58366V2.63281H79.5639L80.0846 4.09438L80.6071 2.63281H82.9131V8.3342H70.7266L73.2388 2.63281Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7006 3.25L71.7266 7.69517H73.0805L73.4529 6.80501H75.4708L75.843 7.69517H77.2306L75.2648 3.25H73.7006ZM73.8702 5.80744L74.4622 4.39236L75.0538 5.80744H73.8702Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2109 7.69508V3.25L79.1141 3.25654L80.0933 5.98927L81.079 3.25H82.9106V7.69508L81.732 7.70551V4.65217L80.6194 7.69508H79.5436L78.4079 4.64174V7.69508H77.2109Z",
    fill: "#016FD0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1389_42518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.997 15.7499L108.999 15.7499C109.954 15.7581 110.738 14.9773 110.75 14.0042L110.75 2.0063C110.746 1.53569 110.559 1.08617 110.23 0.756802C109.901 0.428269 109.459 0.246149 108.997 0.250071L89.0006 0.250062C88.5411 0.246149 88.0986 0.428269 87.7703 0.756802C87.4411 1.08617 87.2538 1.53569 87.25 2.00426L87.25 13.9937C87.2538 14.4643 87.4411 14.9138 87.7703 15.2432C88.0986 15.5717 88.5411 15.7538 89.0028 15.7499H108.997ZM108.996 16.2499C108.996 16.2499 108.995 16.2499 108.995 16.2499L108.997 16.2499H108.996Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6133 16.0002H108.998C109.525 16.0046 110.032 15.7995 110.407 15.4301C110.783 15.0607 110.996 14.5573 111.001 14.0305V11.6719C107.457 13.7062 103.614 15.167 99.6133 16.0002Z",
    fill: "#F27712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.173 9.29595H109.321L108.361 8.02974H108.27V9.29595H107.574V6.15112H108.601C109.403 6.15112 109.867 6.48215 109.867 7.07801C109.867 7.56629 109.577 7.88077 109.056 7.98008L110.173 9.29595ZM109.147 7.10284C109.147 6.79663 108.915 6.63939 108.485 6.63939H108.27V7.59112H108.468C108.915 7.59112 109.147 7.4256 109.147 7.10284ZM105.141 6.15112H107.111V6.68077H105.836V7.38422H107.061V7.92215H105.836V8.77457H107.111V9.30422H105.141V6.15112ZM102.907 9.3787L101.401 6.14284H102.162L103.114 8.26146L104.074 6.14284H104.818L103.296 9.3787H102.923H102.907ZM96.6088 9.37043C95.5495 9.37043 94.7219 8.65043 94.7219 7.71526C94.7219 6.80491 95.5661 6.06836 96.6254 6.06836C96.9233 6.06836 97.1716 6.12629 97.4778 6.2587V6.98698C97.2459 6.75916 96.9339 6.63139 96.6088 6.63112C95.9467 6.63112 95.4419 7.11112 95.4419 7.71526C95.4419 8.3525 95.9385 8.80767 96.6419 8.80767C96.9564 8.80767 97.1964 8.70836 97.4778 8.46008V9.18836C97.1633 9.32077 96.8985 9.37043 96.6088 9.37043ZM94.5067 8.33595C94.5067 8.94836 94.0019 9.37043 93.2736 9.37043C92.744 9.37043 92.3633 9.18836 92.0405 8.77457L92.4957 8.3856C92.653 8.66698 92.9178 8.80767 93.2488 8.80767C93.5633 8.80767 93.7867 8.61732 93.7867 8.36905C93.7867 8.22836 93.7205 8.12077 93.5798 8.03801C93.4256 7.96316 93.265 7.90223 93.0998 7.85595C92.4461 7.64905 92.2226 7.4256 92.2226 6.98698C92.2226 6.47388 92.7026 6.08491 93.3316 6.08491C93.7288 6.08491 94.0847 6.20905 94.3826 6.44077L94.0185 6.85457C93.8741 6.69635 93.6699 6.60622 93.4557 6.60629C93.1578 6.60629 92.9426 6.75526 92.9426 6.95388C92.9426 7.11939 93.0667 7.21043 93.4805 7.35112C94.275 7.59939 94.5067 7.83112 94.5067 8.34422V8.33595ZM91.0888 6.15112H91.784V9.30422H91.0888V6.15112ZM88.8543 9.30422H87.8281V6.15112H88.8543C89.9798 6.15112 90.7578 6.79664 90.7578 7.72353C90.7578 8.19526 90.5261 8.64215 90.1205 8.94008C89.773 9.18836 89.384 9.30422 88.8461 9.30422H88.8543ZM89.6654 6.93733C89.4336 6.75526 89.1688 6.68905 88.7136 6.68905H88.5233V8.77457H88.7136C89.1605 8.77457 89.4419 8.69181 89.6654 8.52629C89.9054 8.32767 90.0461 8.02974 90.0461 7.72353C90.0461 7.41732 89.9054 7.12767 89.6654 6.93733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.413 6.06836C98.5026 6.06836 97.7578 6.79664 97.7578 7.6987C97.7578 8.6587 98.4695 9.3787 99.413 9.3787C100.34 9.3787 101.068 8.65043 101.068 7.72353C101.068 6.79664 100.348 6.06836 99.413 6.06836Z",
    fill: "#F27712"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1389_42518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1389_42518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(31)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1389_42518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(59)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1389_42518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(87)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardOptions);
export default __webpack_public_path__ + "static/media/creditCardOptions.c68b278916cb2ec6feae4508522f669c.svg";
export { ForwardRef as ReactComponent };